// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"S4-z","refreshPageWarning":"T4-z","redirectMessageText":"U4-z"};